<h5 class="vs-log-cinematic-sub-section-wrapper__header">
    {{ header }}
</h5>
<div class="vs-log-cinematic-sub-section-wrapper__body">
    <ng-content></ng-content>
</div>
